const localStorageKey = 'storeeel_cta_click';

export const ctaClickRepository = {
  set(mediaId, campaignId, groupId = null, mediaAssetType = null, isFrequencyInsertContent = false, isFeedFolderContent = false) {
    // プロモーション/フィードフォルダコンテンツは専用プレフィックスで通常コンテンツとのキー衝突を防ぐ
    const keyMediaId = isFrequencyInsertContent ? `fi:${mediaId}` : (isFeedFolderContent ? `ff:${mediaId}` : mediaId);
    const key = (groupId === null || groupId === undefined || groupId === '')
      ? `${keyMediaId}__${campaignId}`
      : `${keyMediaId}__${campaignId}__${groupId}`;

    const existing = JSON.parse(localStorage.getItem(localStorageKey) || "{}");

    existing[key] = {
      mediaId,
      campaignId,
      groupId: (groupId === undefined ? null : groupId),
      mediaAssetType: (mediaAssetType === undefined ? null : mediaAssetType),
      isFrequencyInsertContent: Boolean(isFrequencyInsertContent),
      isFeedFolderContent: Boolean(isFeedFolderContent)
    };

    localStorage.setItem(localStorageKey, JSON.stringify(existing));
  },

  getAllValid() {
    const result = {};

    try {
      const data = JSON.parse(localStorage.getItem(localStorageKey) || "{}");

      Object.entries(data).forEach(([key, info]) => {
        result[key] = info;
      });

      return result;
    } catch {
      return {};
    }
  },

  removeExpired() {
    // 期限なし運用のため、互換用に残しつつ何もしない
  },
  removeByCampaignId(campaignId) {
    const data = JSON.parse(localStorage.getItem(localStorageKey) || "{}");
    const updatedKeys = Object.keys(data).filter(key =>
      key.endsWith(`__${campaignId}`) || key.includes(`__${campaignId}__`)
    );

    if (updatedKeys.length > 0) {
      updatedKeys.forEach(key => delete data[key]);
      localStorage.setItem(localStorageKey, JSON.stringify(data));
    }
  },
  remove(mediaId, campaignId, groupId = null, isFrequencyInsertContent = false, isFeedFolderContent = false) {
    const data = JSON.parse(localStorage.getItem(localStorageKey) || "{}");
    // プロモーション/フィードフォルダコンテンツはそれぞれ "fi:"/"ff:" プレフィックス付きキーで
    // 保存されているため合わせて削除する
    const keyMediaId = isFrequencyInsertContent ? `fi:${mediaId}` : (isFeedFolderContent ? `ff:${mediaId}` : mediaId);
    const key = (groupId === null || groupId === undefined || groupId === '')
      ? `${keyMediaId}__${campaignId}`
      : `${keyMediaId}__${campaignId}__${groupId}`;

    if (key in data) {
      delete data[key];
      localStorage.setItem(localStorageKey, JSON.stringify(data));
    }
  }
};
